import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="py-24 px-4 bg-sage/50 relative overflow-hidden" data-id="element-111">
      {/* Decorative blobs */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-white rounded-full blur-3xl opacity-60 -z-10" data-id="element-112"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white p-8 md:p-16 rounded-[40px] shadow-xl border border-primary/10 relative" data-id="element-114">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-accent text-white px-6 py-2 rounded-full font-bold text-sm tracking-wide shadow-md" data-id="element-115">
            OFERTA POR TIEMPO LIMITADO
          </div>

          <h2 className="font-heading text-3xl md:text-5xl text-primary mb-6 mt-4" data-id="element-116">
            Recupera tu ligereza y tu confianza
          </h2>

          <p className="text-lg md:text-xl text-ink/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-117">
            No tiene por qué costar una fortuna. Queremos que este protocolo
            llegue a todas las madres latinas que lo necesitan hoy mismo. Obtén
            acceso inmediato a <strong data-id="element-118">Cero Inflamación 7D</strong> por una
            inversión única.
          </p>

          <div className="mb-10" data-id="element-119">
            <p className="text-ink/50 line-through text-base mb-1" data-id="element-120">
              Valor Normal: $47.00
            </p>

            <div className="flex items-center justify-center gap-2" data-id="element-121">
              <span className="text-2xl font-medium text-ink" data-id="element-122">Hoy solo:</span>
              <span className="font-heading text-6xl text-cta" data-id="element-123">$6.39</span>
            </div>
            <div className="mt-3 inline-block bg-cta/10 text-cta font-bold text-sm px-4 py-1.5 rounded-full" data-id="element-124">
              ¡AHORRAS 36% EXTRA!
            </div>
          </div>

          <div className="flex flex-col items-center justify-center gap-6" data-id="element-125">
            <CTAButton className="w-full sm:w-auto text-xl py-5 px-10" onClick={() => window.open('https://vidalibresinlimites.com/cart/44150368469076:1', '_blank')} data-id="element-126" />

            <div className="flex items-center gap-2 text-ink/60 text-sm" data-id="element-127">
              <ShieldCheck className="w-5 h-5 text-primary" data-id="element-128" />
              <span data-id="element-129">Acceso inmediato y de por vida al PDF descargable</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}